import Product                  from './product'
import AuthorizationContext     from 'auth/keycloak-instance';
import useTranslate             from 'app/common/hooks/translate';
import useUptimeStatuses        from 'app/common/hooks/uptime-status';

const ProductList = props => {
    const authorizedProducts    = AuthorizationContext.user.authorizedProducts;
    const otherProducts         = AuthorizationContext.user.unAuthorizedProducts
    const t                     = useTranslate();
    const statuses              = useUptimeStatuses();

    const renderProductList = () => {
        return (
            authorizedProducts
            .map((item, index) => (
                <Product
                    item                    = { item }
                    index                   = { index }
                    key                     = { 'p-' + index }
                    toggleApplicationLoader = { (url) => props.toggleApplicationLoader(url) }
                    isAvailable             = { true }
                    status                  = { statuses[item.name] }
                />
            ))
        )
    }
    const renderOtherProductList = () => {
        return (
            otherProducts
            .map((item, index) => (
                <Product
                    item                    = { item }
                    index                   = { index }
                    key                     = { 'p-' + index }
                    toggleApplicationLoader = { (url) => props.toggleApplicationLoader(url) }
                    isAvailable             = { false }
                    status                  = { statuses[item.name] }
                />
            ))
        )
    }

    const isUserHaveAllProducts = () => {
       return !otherProducts.length;
    }

    return (
        <div className="product-selection-container">
            <div className="product-selection-header">
                <div>
                    <h1>{ t('Your_Products') }</h1>
                    <h2>{ t('Your_Product_Message') }</h2>
                </div>
                <div>
                    {/* <a href={ window.REACT_APP_SIMPRA_REPORTS_URL } rel="noreferrer" target="_blank" className="reports-link">{ t('Reports') }</a> */}
                    <a href="https://status.simprasuite.com/" rel="noreferrer" target="_blank">{ t('Status') }</a>
                </div>
            </div>
            <div className="product-list-container">
                { renderProductList() }
            </div>
            {
                isUserHaveAllProducts()
                    ?   null
                    :   <div className="other-products">
                            <h1>{ t('Meet_Our_Products') }</h1>
                            <h2>{ t('Meet_Our_Products_Description') }</h2>
                            <div className="product-list-container others">
                                { renderOtherProductList() }
                            </div>
                        </div>
            }
            
        </div>
    )
}

export default ProductList